var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 16 1.455-1.455-5.506-5.506L3.1 8l.848-1.039 5.507-5.506L8 0 0 8z"
  })));
};

export default SvgChevronLeft;